import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { santaClient } from '@src/state/client';
import { showToast } from '@src/components/Toast';

/** Called only after a successful clipboard write; never stores the access URL. */
export function usePersonalLinkCopied(
  key: string,
  markLinkInvited: (id: number) => void,
  onChanged: () => Promise<void> | void,
) {
  const { t } = useTranslation();
  return useCallback(async (id: number) => {
    markLinkInvited(id);
    try {
      const result = await santaClient.recordPersonalLinkCopied({ key, id, requestId: crypto.randomUUID() });
      if (!result.ok) throw new Error('activity recording failed');
    } catch {
      showToast(t('boxActivity.linkCopyRecordFailed'));
      return;
    }
    // A refresh failure does not invalidate either the copy or the recorded event.
    try { await onChanged(); } catch { /* refreshed on next page load */ }
  }, [key, markLinkInvited, onChanged, t]);
}
